module.exports = __webpack_public_path__ + "Corbel.9cddf979e5e6b9938733.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Corbel.ttf
// module id = 838
// module chunks = 2